import { render, staticRenderFns } from "./communityMember.vue?vue&type=template&id=2d6c0634&scoped=true"
import script from "./communityMember.vue?vue&type=script&lang=js"
export * from "./communityMember.vue?vue&type=script&lang=js"
import style0 from "./communityMember.vue?vue&type=style&index=0&id=2d6c0634&prod&scoped=true&lang=css"
import style1 from "./communityMember.vue?vue&type=style&index=1&id=2d6c0634&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6c0634",
  null
  
)

export default component.exports